/* eslint camelcase: 0 */

import { Publication as Data } from '@/typings/api/Publication'
import { Model, createMessages } from '@/helpers/Model'


export class PublicationModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить публикацию',
    edit: 'Редактировать публикацию',
    view: (data: PublicationModel) => 'Публикация «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Публикации',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: PublicationModel) => 'Удаление публикации «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных публикаций',
    delete_all_partly: 'Удаление части выбранных публикаций',
    archive_all: 'Архивирование выбранных публикаций',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
